import React, { useState } from 'react';

import { PrimaryButton } from '@components/library/button/index';
import WidgetForm from './widget_form';

interface WidgetEmptyTemplateProps {
  brandHexColor: string;
  triggerCardsRefresh: () => void;
}

const WidgetEmptyTemplate: React.FunctionComponent<WidgetEmptyTemplateProps> = ({
  brandHexColor,
  triggerCardsRefresh
}) => {
  const [showForm, setShowForm] = useState(false);
  const toggleForm = (): void => setShowForm((prevState) => !prevState);

  return (
    <section className="widgets" style={{ backgroundColor: `#${brandHexColor}` }}>
      <div className="widgets-container">
        <div className="widgets-third widget-create-card template">
          <span className="bff-face-sad" />
          <h3>{t("You don't have any widgets yet!")}</h3>
          <p>{t("Use a widget feed to give your team insight into realtime changes and updates within your Brandfolders.")}</p>
          <p>{t("Customizable options for your widget feeds include recently created assets, assets that are expiring soon, your most popular assets, etc.")}</p>
          <PrimaryButton
            className="widget-create-button"
            icon="bff-plus"
            onClick={toggleForm}
          >
            {t("Create Widget")}
          </PrimaryButton>
        </div>
        <div className="widgets-third widget-placeholder-card template">
          <div className="widget-placeholder-image" style={{ backgroundImage: `url("https://cdn.brandfolder.io/27C9EC93/at/q6y18n-8wjz1k-fi9mwk/image-placeholder.auto")` }} role="img" aria-label="thumbnail placeholder" />
          <div className="widget-placeholder-text" style={{ backgroundImage: `url("https://cdn.brandfolder.io/27C9EC93/at/q6y1al-7x2y1s-dl1522/text-placeholder.auto")` }} role="img" aria-label="text placeholder" />
          <div className="widget-placeholder-image" style={{ backgroundImage: `url("https://cdn.brandfolder.io/27C9EC93/at/q6y18n-8wjz1k-fi9mwk/image-placeholder.auto")` }} role="img" aria-label="thumbnail placeholder" />
          <div className="widget-placeholder-text" style={{ backgroundImage: `url("https://cdn.brandfolder.io/27C9EC93/at/q6y1al-7x2y1s-dl1522/text-placeholder.auto")` }} role="img" aria-label="text placeholder" />
        </div>
        <div className="widgets-third widget-placeholder-card template">
          <div className="widget-placeholder-image" style={{ backgroundImage: `url("https://cdn.brandfolder.io/27C9EC93/at/q6y18n-8wjz1k-fi9mwk/image-placeholder.auto")` }} role="img" aria-label="thumbnail placeholder" />
          <div className="widget-placeholder-text" style={{ backgroundImage: `url("https://cdn.brandfolder.io/27C9EC93/at/q6y1al-7x2y1s-dl1522/text-placeholder.auto")` }} role="img" aria-label="text placeholder" />
          <div className="widget-placeholder-image" style={{ backgroundImage: `url("https://cdn.brandfolder.io/27C9EC93/at/q6y18n-8wjz1k-fi9mwk/image-placeholder.auto")` }} role="img" aria-label="thumbnail placeholder" />
          <div className="widget-placeholder-text" style={{ backgroundImage: `url("https://cdn.brandfolder.io/27C9EC93/at/q6y1al-7x2y1s-dl1522/text-placeholder.auto")` }} role="img" aria-label="text placeholder" />
        </div>
        {showForm && (
          <WidgetForm
            closeModal={toggleForm}
            triggerCardsRefresh={triggerCardsRefresh}
          />
        )}
      </div>
    </section>
  );
};

export default WidgetEmptyTemplate;
